import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Ayuda } from "./Glosario";

const n = (v) => Math.round(v || 0).toLocaleString("es-PY");
const ETQ = { agricola: "Agrícola", arroz: "Arroz", pastura: "Pastura", bosque: "Bosque" };

export function ValorMercado({ cod, padron }) {
  const [v, setV] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get("/portal/titulares/parcela/valor", { params: { cod, padron } }).then((r) => setV(r.data)).catch((e) => setErr(formatApiErrorDetail(e?.response?.data?.detail)));
  }, [cod, padron]);
  if (err) return <p className="text-xs text-amber-700" data-testid="valor-mercado-error">{err}</p>;
  if (!v) return null;
  return <div className="rounded-xl border border-emerald-200 bg-emerald-50/60 p-3 space-y-1.5" data-testid="valor-mercado">
    <p className="text-xs text-slate-500">Valor de mercado estimado<Ayuda k="valor_mercado" /></p>
    <p className="text-lg font-bold text-[#1f5f3f]" data-testid="valor-mercado-rango">USD {n(v.bajo)} – {n(v.alto)}</p>
    <p className="text-xs text-slate-700" data-testid="valor-mercado-ha">≈ USD {n(v.bajo_ha)} – {n(v.alto_ha)} /ha</p>
    <p className="text-xs text-slate-600" data-testid="valor-mercado-gs">≈ Gs. {n(v.bajo_gs)} – {n(v.alto_gs)} <span className="text-slate-400">(USD 1 = Gs. {n(v.usd_pyg)})</span></p>
    {v.desglose.length > 0 && <ul className="text-[11px] text-slate-600 pt-1 border-t border-emerald-100" data-testid="valor-mercado-desglose">
      {v.desglose.map((d) => <li key={d.tipo} className="flex justify-between"><span>{ETQ[d.tipo]} · {d.ha.toLocaleString("es-PY")} ha</span><span>USD {n(d.bajo)} – {n(d.alto)}</span></li>)}
    </ul>}
    <p className="text-[11px] text-slate-500">Referencia: {v.referencia}{v.por_defecto && v.departamento ? ` (${v.departamento} sin valores propios)` : ""}</p>
    <p className="text-[11px] font-semibold text-amber-800" data-testid="valor-mercado-aviso">Estimación de referencia por zona y uso del suelo. No es una tasación.</p>
    <p className="text-[10px] text-slate-400" data-testid="valor-mercado-fuentes">Fuentes: {v.fuentes}</p>
  </div>;
}
